module.exports = __webpack_public_path__ + "img/jp_bg.0bea5807.png";